export default __webpack_public_path__ + "static/media/R5.fdb2db93.png";